import { render, staticRenderFns } from "./helpcenter-guides.vue?vue&type=template&id=3f5dcf02&"
import script from "./helpcenter-guides.vue?vue&type=script&lang=js&"
export * from "./helpcenter-guides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports